import { useCallback, useMemo } from 'react';

import useUnsavedDataAlert from 'components/hooks/useUnsavedDataAlert';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { roundOffToPlaces } from 'constants/helper';

import {
  setEditableRowData,
  useSelectEditableRowData,
  useSelectInitialRowDataCheckIn,
} from '../slice/CheckInIntentSlice';

export const useHandleUnsavedDataCheckIn = () => {
  const emptyInitialRowData = useMemo(() => [], []);
  const initialRowData = useSelectInitialRowDataCheckIn() || emptyInitialRowData;
  const editableRowData = useSelectEditableRowData() || [];
  const dispatch = useDispatch();
  const editedRows = editableRowData.filter((row, index) => {
    const { progressLevel, closureStatus, achieved, newComment = '' } = row;
    const {
      progressLevel: initialProgressLevel,
      closureStatus: initialClosureStatus,
      achieved: initialAchieved,
      newComment: initialNewComment = '',
    } = initialRowData[index] || {};

    return (
      progressLevel !== initialProgressLevel ||
      closureStatus !== initialClosureStatus ||
      roundOffToPlaces(+achieved, 2) !== roundOffToPlaces(+initialAchieved, 2) ||
      newComment !== initialNewComment
    );
  });

  const totalEditedRows = editedRows.length;

  const { showUnsavedDataAlertDialog } = useUnsavedDataAlert();
  const location = useLocation();
  const isCheckInScreen = location.pathname.includes('goal/check-in/');
  const handleUnsavedDataAlert = useCallback(
    (callbackFunction) => {
      if (totalEditedRows === 0 || !isCheckInScreen) {
        callbackFunction();
        return;
      }
      showUnsavedDataAlertDialog({
        onCancelCallback: () => {
          dispatch(
            setEditableRowData({
              rowData: initialRowData
                ? initialRowData.map((row) => ({ ...row, achieved: `${roundOffToPlaces(+row.achieved, 2)}` }))
                : [],
            })
          );
          callbackFunction();
        },
      });
    },
    [dispatch, initialRowData, isCheckInScreen, showUnsavedDataAlertDialog, totalEditedRows]
  );

  return { handleUnsavedDataAlert };
};
